import { sanitizePostAuthReturnUrl } from "@bevco/Utilities/sanitizePostAuthReturnUrl";
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import validateEmail from "@insite/client-framework/Common/Utilities/validateEmail";
import { ExternalProviderLinkCollectionModel } from "@insite/client-framework/Services/IdentityService";
import { removeAbsoluteUrl } from "@insite/client-framework/Store/Data/Pages/PageSelectors";

export const AUTO_SSO_PENDING_CLASS = "bevco-auto-sso-pending";

declare global {
    interface Window {
        __bevcoAutoSsoProvidersPromise?: Promise<ExternalProviderLinkCollectionModel | null>;
    }
}

/** True when Sign In should skip the form and start external SSO immediately. */
export const shouldAutoSignInExternalSso = (
    search: string,
    enableStorefrontSso: boolean,
): { shouldAutoSso: boolean; username: string } => {
    if (!enableStorefrontSso) {
        return { shouldAutoSso: false, username: "" };
    }

    const parsed = parseQueryString<{ username?: string; externalError?: string }>(search);
    if (parsed.externalError) {
        return { shouldAutoSso: false, username: "" };
    }

    const username = parsed.username?.trim() || "";
    if (!username || !validateEmail(username)) {
        return { shouldAutoSso: false, username };
    }

    return { shouldAutoSso: true, username };
};

/**
 * Landing URL when the user is already signed in on Sign In.
 * Prefer safe ?returnUrl=, otherwise home.
 */
export const resolveSignedInSignInLandingUrl = (search: string, homePageUrl?: string): string => {
    const queryReturnUrl = parseQueryString<{ returnUrl?: string }>(search).returnUrl;
    const sanitized = sanitizePostAuthReturnUrl(removeAbsoluteUrl(queryReturnUrl));
    return sanitized || homePageUrl || "/";
};

/** Clears the pre-hydration hide class if SSO redirect does not happen. */
export const clearAutoSsoPendingUi = () => {
    if (typeof document === "undefined") {
        return;
    }

    document.documentElement.classList.remove(AUTO_SSO_PENDING_CLASS);
};
